import React from "react";
import moment from 'moment';
import { utils_tool, component_tool, framework_tool } from "@/tool";
let {WizModal} = component_tool;
import { WizTableForm } from '../../common'
let {$$,checkStrLength} = utils_tool;
import HighSet from "@/containers/common/highSet";
//配置项
let componentName = 'classManagement';
const trainSite = WizTableForm.Config.trainSite(this, {
  apiParams: {
   status: 0, type:0, auditType:0,allowOrder:0,dataPerms_sceneTypeIdList: [125], managerType:1
 }
})
const userConfig = WizTableForm.Config.user(this, { apiParams: { status: 1,roleConfig: "teacherRole" } });

import { WizClassifySelect } from '@/containers/common'
let ref;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
}
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    name: "delFlag",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "班级名称",
    name: "searchName",
    searchItem: {}
  },
  {
    title: "班级名称",
    name: "name",
    tableItem: {
      width: 120,
    },
    formItem: {
      rules: [{
        required: true,
        message: '请输入名称',
      }, {
        max: 25,
        message: '名称长度不能超过25个字符'
      }],
      placeholder: "请输入"
    }
  },
  {
    title: "班级类型",
    name: "type",
    dict: [
      {code: 0, codeName: "线下班级"},
      {code: 1, codeName: "线上班级"},
    ],
    tableItem: {
      width: 100,
    },
  },
  {
    title: "所属主题",
    name: "searchProgramName",
    searchItem: {}
  },
  {
    title: '班级时间',
    name: 'classDate',
    dataIndex: "classDate",
    // tableItem: {
    //   width: 350,
    //   render: (text, record) => {
    //     const {startDate,endDate} = record;
    //     let classDate = formatterDate(startDate)+" ~"+formatterDate(endDate);
    //     return classDate
    //   }
    // },
    searchItem: {
      type: 'date~',
      showTime: true
    },
  },
  {
    title: "开始时间",
    name: "startDate",
    tableItem: {
      width: 180,
    },
  },
  {
    title: "结束时间",
    name: "endDate",
    tableItem: {
      width: 180,
    },
  },
  {
    title: "介绍",
    name: "intro",
    formItem: {
      type: 'textarea'
    },
  },
  // {
  //   title: "教室",
  //   name: "trainSiteName",
  //   tableItem: {
  //     width: 100,
  //   },
  // },
  // {
  //   title: "培训中心",
  //   name: "address",
  //   tableItem: {
  //     width: 100,
  //   },
  // },
  {
    title: "状态",
    name: "statusList",
    dataIndex: "status",
    searchItem: {
      type: 'select',
      mode: 'multiple',
      formatInit: () => [0,1]
    },
    dict: [
      { code: 0, codeName: '草稿' },
      { code: 1, codeName: '已发布' },
      { code: 2, codeName: '已关闭' }
    ],
  },
 {
    title: "状态",
    name: "status",
    dict: [
      {code: 0, codeName: "草稿"},
      {code: 1, codeName: "已发布"},
      {code: 2, codeName: "已关闭"}
    ],
    tableItem: {
      width: 100,
    },
  }, 
  {
    title: "班级类型",
    name: "type",
    dict: [
      {code: 0, codeName: "线下班级"},
      {code: 1, codeName: "线上班级"},
    ],
    searchItem: {
      type: "select"
    },
    formItem: {
      type: "radio"
    }
  },
  {
    title: '教室',
    name: 'trainSiteId',
    searchItem: {
      type: 'select',
      selectType: 'radio',
      diy: WizTableForm,
      ...trainSite
    }
  },

  {
    title: "限制人数",
    name: "limitNum",
    tableItem: {
      width: 100,
    },
    formItem: {}
  },
  {
    title: "已参加人数",
    name: "studentCount",
    tableItem: {
      width: 100,
    },
    formItem: {}
  },
  {
    title: "实际可参加人数",
    name: "realJoinCount",
    tableItem: {
      width: 130,
    },
    formItem: {}
  },
  {
    title: "所属主题",
    name: "programName",
    tableItem: {
      width: 100,
    },
    formItem: {}
  },
  {
    title: "主题分类",
    name: "typeName",
    tableItem: {

    },
    formItem: {}
  },
  {
    title: "主题分类",
    name: "typeList",
    dict: [],
    formItem: {  width: 100,},
    searchItem: {
      type: 'diy',
      diy: WizClassifySelect,
      returnKey: true,
      wizTreeSelectListProps: {
        itemProps: {
          icon: 'unordered-list',
          title: '主题分类',
          tips: '请勾选所属猪头分类'
        },
        treeProps: { checkStrictly: true }
      },
      apiProps: { type: 1 },
      selectProps: {
        placeholder: '请选择主题分类'
      },
    },

  },
  {
    title: '讲师',
    name: 'lectureIds',
    searchItem: {
      type: 'select',
      selectType: 'checkbox',
      diy: WizTableForm,
      ...userConfig
    }
  },
  // {
  //   title: "课程类别",
  //   name: "programCategory",
  //   dict: [
  //     { code: 0, codeName: "普通课程" },
  //     { code: 1, codeName: "新能源课程" },
  //   ],
  //   tableItem: {
  //   },
  //   // searchItem: {
  //   //   type: "select"
  //   // },
  // },
  // {
  //   title: '组班群聊',
  //   name: 'hasTeam',
  //   dict: [
  //     {code: 0, codeName: '否'},
  //     {code: 1, codeName: '是'},
  //   ],
  //   tableItem: {
  //     width: 100
  //   },
  //   searchItem: {
  //     type: 'select'
  //   }
  // },
  // {
  //   title: "群聊状态",
  //   name: "teamState",
  //   dict: [
  //     {code: 0, codeName: '未开启'},
  //     {code: 1, codeName: '已开启'},
  //     {code: 2, codeName: '已解散'},
  //   ],
  //   tableItem: {
  //     width: 100,
  //   },
  //   searchItem: {
  //     type: 'select'
  //   }
  // },
  {
    title: "满意度评分",
    name: "scoreAvg",
    tableItem: {

    },
  },
];

const templateConfig = (data) => {
  let {pathname} = data
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns,
        searchBarProps: {
          dataFormat: (params) => {
            // let fitterValues = {};
            // Object.keys((v)).forEach(key =>{
            //   const value = v[key];
            //   if (key === 'classDate' && value != null && value != undefined) {
            //     fitterValues['startDate'] = value[0].format("YYYY-MM-DD HH:mm:ss");
            //     fitterValues['endDate'] = value[1].format("YYYY-MM-DD HH:mm:ss");
            //   } else if (value != null && value != undefined) {
            //     fitterValues[key] = value;
            //   }
            // });
            // return fitterValues

            let value = Object.assign({}, params)
            if (value.classDate && value.classDate.length === 2) {
              value.startDate = moment(value.classDate[0]).format('YYYY-MM-DD HH:mm:ss')
              value.endDate = moment(value.classDate[1]).format('YYYY-MM-DD HH:mm:ss')
            }else{
              value.startDate = undefined;
              value.endDate = undefined;
            }
            // delete value.time
            return value
          },
          // cols: {
          //   xs: 24,
          //   md: 12,
          //   xl: 8
          // },
          buttonSort: ['add', 'export'],
          buttons: [
            {
              key: 'add',
              custom: true,
              params: { icon: 'plus', children: '新增', type: 'primary'},
              customOnClick: {
                key: 'jumpPage',
                params: {
                  key: 'push',
                  pathname: pathname + '/classDetailAdd'
                }
              }
            },
            {
              key: "export",
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export'},
              customOnClick: {
                key: "action",
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters,callback) => {
                  return {...filters}
                }
              }
            }
          ]
        },
        modalFormProps: {
          key: "modal123",
          params: {
            modalParams: {
              title: "Modal",
              children: "Bla bla123 .."
            }
          }
        },
        dataTableProps: {
          rowKey: "id",
          selectType: "checkbox",
          isScroll: true,
          bordered: false,
          paging: false,
          loading: false,
        },
        rowOperateSort: ['look','update', 'releaseOrClose', 'classroomAssistant', 'classStudents', 'scoreManagement'/*, 'exportDoorStickers'*/, 'classCopy','advancedSet', 'announcement', 'album', 'comment'],
        rowOperateView: [
          {
            key: "comment",
            custom: true,
            params: { children: "班级评论" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/comment"
              }
            }
          },
          {
            key: "announcement",
            custom: true,
            params: { children: "班级公告" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/announcement"
              }
            }
          },
          {
            key: "album",
            custom: true,
            params: { children: "班级相册" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/album"
              }
            }
          },
          {
            key: "look",
            custom: true,
            params: { children: "查看" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/lookClassInfo"
              }
            }
          },
          // {
          //   key: "look",
          //   custom: true,
          //   params: { children: "查看" },
          //   customOnClick: {
          //     key: "modal",
          //     params: {
          //       modalParams: {
          //         title: "查看班级",
          //         diy: (e) => {
          //           return (
          //             <LookClassInfo
          //               key={'classInfoManagement' + e.record.id}
          //               {...e}
          //             />
          //           )
          //         },
          //         footer:null,
          //       }
          //     },
          //     formatParams: (rows, record, filter) => {
          //       return { ...record };
          //     }
          //   }
          // },
          {
            key: "releaseOrClose",
            custom: true,
            params: {children: "发布"},
            textFormat: {
              recordKey: 'status',
              dirt: {0: '发布',2: '发布', 1: '关闭'}
            },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updateClassStatus",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                let statusNameStr= record['status'] === 0 ||  record['status'] === 2 ? "发布" : "关闭";
                const content = `您确定要`+statusNameStr+`该班级吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      status:  record['status'] === 0 ||  record['status'] === 2 ? 1 : 2,
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            }
          },
          {
            key: "update",
            custom: true,
            params: { children: "编辑"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/classDetailUpd"
              }
            }
          },
          {
            key: "classroomAssistant",
            custom: true,
            params: { children: "课堂助手"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/classAideDetail"
              }
            }
          },
          {
            key: "classStudents",
            custom: true,
            params: { children: "班级学员"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/classStudentList"
              }
            }
          },
          {
            key: "scoreManagement",
            custom: true,
            params: { children: "成绩管理"},
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/classResult"
              }
            }
          },
          {
            key: "exportDoorStickers",
            custom: true,
            params: { children: "导出门贴"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "exportLabels",
                apiParams: {}
              },
              formatParams: (rows, record, filters,callback) => {
                return {...record}
              }
            }
          },
          {
            key: "classCopy",
            custom: true,
            params: { children: "班级复制" },
            customOnClick: {
              key: "jumpPage",
              params: {
                key: "push",
                pathname: pathname + "/classDetailCopy"
              }
            }
          },
          {
            key: "createClassTeam",
            custom: true,
            params: { children: "创建群聊" },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "createClassTeam",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要创建群聊吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let {hasTeam, status, teamState, programCategory} = record;
              return {
                disabled: programCategory !== 0 || hasTeam !== 1 || status !== 1,
                hidden: teamState === 1
              };
            }
          },
          {
            key: "removeClassTeam",
            custom: true,
            params: { children: "删除群聊" },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "removeClassTeam",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要删除群聊吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let {status, teamState, programCategory} = record;
              return {
                disabled: programCategory !== 0 || status === 1,
                hidden: teamState === 0 || teamState === 2
              };
            }
          },
          {
            key: "syncClassTeam",
            custom: true,
            params: { children: "同步班级群聊" },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "syncClassTeam",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要同步群聊吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let {status, teamState, programCategory} = record;
              return {
                disabled: programCategory !== 0 || teamState !== 1,
                hidden: teamState !== 1,
              };
            }
          },
          {
            key: 'advancedSet',
            custom: true,
            params: {children: '高级设置'},
            customOnClick: {
              key: 'modal',
              params: {
                modalParams: {
                  title: '高级设置',
                  bordered: true,
                  footer: null,
                  destroyOnClose: true,
                  diy: (e) => {
                    return <>
                      <HighSet data={{record: e.record,bizType: 36}}
                              changeModal={e.changeModal}
                      />
                    </>
                  },
                  width: 950
                },
              }
            },
            recordChangeParams: ({record, rows}) => {
              let disabled = true
              if (record && record['status'] === 1) {
                disabled = false
              }
              return {disabled}
            }
          },
        ],
        commonOperate: {
          add: true,
          delete: false,
          update: true,
          look: true
        }
      }
    }
  }
};

const apis = (params = {}) => {
  return{
    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@getListByPage`,
        apiParams: {pageNum: 1, pageSize: 10,statusList: [0,1], ...(params || {}) }
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {}
      }
    },
    update: {
      path: `${componentName}/update`,
      payload: {
        key: `${componentName}@update`,
        apiParams: {}
      }
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {}
      }
    },
    updateClassStatus: {
      path: `${componentName}/updateClassStatus`,
      payload: {
        key: `${componentName}@updateClassStatus`,
        apiParams: {}
      }
    },
    export: {
      path: `${componentName}/export`,
      payload: {
        key: `${componentName}@export`,
        apiParams: { statusList: [0,1], ...(params || {}) }
      }
    },
    exportLabels: {
      path: `${componentName}/exportLabels`,
      payload: {
        key: `${componentName}@exportLabels`,
        apiParams: {}
      }
    },
    createClassTeam: {
      path: `${componentName}/createClassTeam`,
      payload: {
        key: `${componentName}@createClassTeam`,
        apiParams: {}
      }
    },
    removeClassTeam: {
      path: `${componentName}/removeClassTeam`,
      payload: {
        key: `${componentName}@removeClassTeam`,
        apiParams: {}
      }
    },
    syncClassTeam: {
      path: `${componentName}/syncClassTeam`,
      payload: {
        key: `${componentName}@syncClassTeam`,
        apiParams: {}
      }
    }
  }
}


let reduxTemplateCofig = (args) => {
  return {
    apis: apis(args['params']),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    keepInitApiParams: true,
    ...args
  }
};

export {reduxTemplateCofig, templateConfig};
